import React from "react";
import Heading from "../Products/Heading";
import Product from "../Products/Product";
import {
  bestSellerOne,
  bestSellerTwo,
  bestSellerThree,
  bestSellerFour,
} from "../../../assets/images/index";

const BestSellers = () => {
  return (
    <div className="w-full pb-20">
      <Heading heading="Our Recent works" />
      <div className="w-full grid grid-cols-1 md:grid-cols-2 lgl:grid-cols-3 xl:grid-cols-4 gap-10">
        <Product
          _id="1011"
          img={bestSellerOne}
          productName="Fridge"
          price=""
          color="all kind"
          badge={true}
          des="Available."
        />
        <Product
          _id="1012"
          img={bestSellerTwo}
          productName="freezer"
          price=""
          color="all"
          badge={false}
          des="Available."
        />
        <Product
          _id="1013"
          img={bestSellerThree}
          productName="repairs"
          price=""
          color="all"
          badge={true}
          des="Available."
        />
        <Product
          _id="1014"
          img={bestSellerFour}
          productName="repaired cooker"
          price=""
          color="all"
          badge={false}
          des="Available."
        />
      </div>
    </div>
  );
};

export default BestSellers;
